export const CONTRACT_TABLE_SEARCH_CATEGORIES = [
  {value: 'contractNumber', label: 'Номер договора'},
  {value: 'companyName', label: 'Заказчик'},
] as const;

export const CONTRACT_TABLE_SEARCH_PLACEHOLDERS = {
  contractNumber: 'Поиск по номеру договора',
  companyName: 'Поиск по заказчику',
} as const;
